var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsnewCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-whatsnew-customize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.5 21 22.5 19.5 24.15 25.5 24.9 24 27.9 27 30 24.9 27 21.9 28.5 21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,12.75A10.3,10.3,0,0,0,24.9,8.4l1.65-2.85-2.1-2.1L21.6,5.1a12.19,12.19,0,0,0-4.35-1.8L16.5,0h-3l-.75,3.15A15.16,15.16,0,0,0,8.25,5.1L5.4,3.3,3.3,5.4,5,8.25a12.19,12.19,0,0,0-1.8,4.35L0,13.5v3l3.15.75A10.3,10.3,0,0,0,5,21.6L3.3,24.45l2.1,2.1L8.25,24.9a12.19,12.19,0,0,0,4.35,1.8l.9,3.3h3l.75-3.15a12.82,12.82,0,0,0,3.6-1.35l-1.2-4.65a7.75,7.75,0,0,1-4.8,1.65,7.5,7.5,0,0,1,0-15,7.52,7.52,0,0,1,7.5,7.5,4.15,4.15,0,0,1-.15,1.35s4.35,1,4.35.9L30,16.5v-3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsnewCustomize);
export default __webpack_public_path__ + "static/media/icon-whatsnew-customize.7102ee327cc5fbe210e9b04d2233327e.svg";
export { ForwardRef as ReactComponent };